// @ts-check
import Vue from 'vue';
import LocalStorageService from '@bto-services/storage/local-storage-service';

export const TOASTS_STORAGE_KEY = 'toast-notifications';

/**
 * @typedef {import('bto-models/toast-notification/interfaces').ToastNotification} ToastNotification
 */


/**
 * Get default state for betslip 
 */
export const getDefaultState = () => ({
  /**
   * @type {{[userId_identifier:string]: ToastNotification}}
   */
  messages: {},
});
/**
 * Get default/saved state from local storage
 * @param {ReturnType<getDefaultState>} savedState - last saved state if any
 * @returns default state plus saved state
 */
const getSavedState = (savedState) => ({
  ...getDefaultState(),
  ...savedState,
});

const savedToastNotificationStore = LocalStorageService.get(TOASTS_STORAGE_KEY) || {};

export const toastStore = Vue.observable(getSavedState(savedToastNotificationStore));

/**
 * Function to save toast state to localstorage
 */
export const saveToastStore = () => {
  LocalStorageService.set(TOASTS_STORAGE_KEY, toastStore);
};